import type { User } from "firebase/auth";
import { signOutCoach } from "../auth";
import { Backdrop } from "../components/Backdrop";

export default function NotACoach({ user }: { user: User }) {
    return (
        <div className="signin">
            <Backdrop />
            <div className="card glass">
                <h1>This account is not set up as a coach</h1>
                <p className="muted">
                    You are signed in as {user.email ?? user.displayName ?? "an anonymous session"}. Coaches are added by their club or by Swana.
                    If you coach at a Swana venue, ask the club to approve you in the app, or contact Swana.
                </p>
                <button className="btn" onClick={() => void signOutCoach()}>Sign out and use another account</button>
            </div>
        </div>
    );
}
